<template>
  <a-row>
    <a-space v-if="editIs" class="m-8">
      <a-button type="primary" v-hasPermi="['bom:bomRoutingLineCcItem:add']" @click="onMaterialModalShow">新增</a-button>
      <a-button v-hasPermi="['bom:bomRoutingLineCcItem:import']" @click="onImportList">导入</a-button>
      <a-button v-hasPermi="['bom:bomRoutingLineCcItem:list']" @click="getTableList">刷新</a-button>
    </a-space>
    <ls-api-table
      ref="dataTable"
      :tableProps="tableProps"
      :columns="columns"
      :scroll="{ x: 400, fixScreen: true }"
      bordered
    >
      <template #edmitOperation="{ record, index }">
        <template v-if="editIs">
          <a-icon v-if="record.loading" type="loading" />
          <template v-if="!record.editIs && !record.loading">
            <ls-cancel @confirm="onDeleteRow(record, index)" title="确定要删除吗?" v-hasPermi="['bom:bomRoutingLineCcItem:remove']">
              <a-icon type="delete" title="删除" />
            </ls-cancel>
          </template>
        </template>
      </template>
    </ls-api-table>
    <MaterialSelectModal
      ref="selectModalRef"
      :detailData="detailData"
      @successCall="getTableList"
    />
    <ImportModal ref="importModalRef" @successCall="getTableList" />
  </a-row>
</template>

<script>
import {
  apiGetRoutingLineCcItem,
  apiDeleteRoutingLineCcItem
} from '@/api/mes/basedata/standardProcessNew';
import { generateLsTableResData } from '@/utils/util'
import MaterialSelectModal from './material-select-modal.vue'
import ImportModal from './import-modal.vue';
export default {
  name: 'MaterialTable',
  components: { MaterialSelectModal, ImportModal },
  props: {
    editIs: {
      type: Boolean,
      default: true
    },
    detailData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      materialForm: this.$form.createForm(this, { name: 'add-modal-form' }),
      tableProps: {
        requestApi: generateLsTableResData(apiGetRoutingLineCcItem)
      },
      columns: [
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center'
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          customRender: text => <a-tooltip tiltle={text} placement="topLeft"><div class="text-3-ellipsis">{text}</div></a-tooltip>,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'edmitOperation',
          scopedSlots: { customRender: 'edmitOperation' },
          align: 'center',
          width: 100
        }
      ]
    }
  },
  mounted() {
    this.getTableList()
  },
  methods: {
    getTableList(currentPage) {
      const { id: routingId } = this.detailData;
      if(routingId) {
        this.$refs.dataTable.searchParams = { routingId };
        this.$refs.dataTable.getData(!!currentPage);
      }
    },
    onImportList() {
      this.$refs.importModalRef.show({
        url: '/bom/bomRoutingLineCcItem/import/' + this.detailData.id,
        templateUrl: '/bom/bomRoutingLineCcItem/template'
      });
    },
    onMaterialModalShow() {
      this.$refs.selectModalRef.show();
    },
    onMaterialOk() {
      this.$refs.form.validate(valid => {
        if(valid) {
          this.dataSoucrce.unshift(...this.selectMaterialList);
        }
      })
    },
    onDeleteRow(record, index) {
      this.$emit('delete', record, index);
      this.$set(record, 'loading', true)
      apiDeleteRoutingLineCcItem(record.id).then((res) => {
        if(res.code === 200) {
          this.$message.success('保存成功');
          this.getTableList();
        }
      }).finally(() => {
        record.loading = false;
      });
    }
  }
}
</script>

<style lang="less" scoped>
.full-width {
  width: 100%;
}
.m-8 {
  margin: 8px 0;
}
.m-r-8 {
  margin-right: 8px;
}
.text-3-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  word-break: break-all;
}
</style>
